import { CommonModule } from '@angular/common';
import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-modal-lateral',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-lateral.component.html',
  styleUrls: ['./modal-lateral.component.scss'],
})
export class ModalLateralComponent implements OnChanges, OnInit {
  @ViewChild('modalLateral', { static: true })
  public modalLateralRef!: ElementRef;

  @ContentChild('conteudo', { static: true })
  public conteudoTemplate!: TemplateRef<any>;

  @Input({ required: true })
  public opcaoParaAbrir: boolean = false;
  @Input() public width: string | number = '50%';
  @Output() public esconder = new EventEmitter();

  private elementoAnteriorFocado!: HTMLElement;
  protected widthElement = this.width;

  @HostListener('window:resize')
  public onResize() {
    this.atualizarLargura();
  }

  ngOnInit(): void {
    if (this.opcaoParaAbrir) this.abrirModal();
    this.atualizarLargura();
  }

  ngOnChanges() {
    if (this.opcaoParaAbrir) this.abrirModal();
    else this.fecharModal();

    this.atualizarLargura();
  }

  public abrirModal() {
    this.elementoAnteriorFocado = document.activeElement as HTMLElement;
    this.modalLateralRef.nativeElement.focus();
  }

  public fecharModal() {
    if (this.elementoAnteriorFocado) {
      this.elementoAnteriorFocado.focus();
    }

    this.esconder.emit();
  }

  public verificarFechamentoComEsc(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      this.fecharModal();
    }
  }

  private atualizarLargura() {
    const larguraTela = window.innerWidth;

    if (larguraTela <= 720) {
      this.widthElement = '100%';
    } else if (larguraTela <= 900) {
      this.widthElement = '80%';
    } else {
      this.widthElement =
        typeof this.width === 'number' ? `${this.width}px` : this.width;
    }
  }
}
